<template>
	<div class="topleft" @click="Drawer">
		<span class="wordlang" @click.stop="changeLangEventleft">{{$t("charpter-one.cp-one-top.title[4]")}}</span>
		<div class="part1">
			<span class="line"></span>
			<div class="left-wrapper">
					<router-link class="wrapper" to="/brightmain">
					<span class="word first">{{word[0]}}</span>
					</router-link>
					<router-link class="wrapper" to="/aboutUs">
							<span class="word">{{word[1]}}</span>
					</router-link>
					<router-link class="wrapper" to="/prouductCenter">
							<span class="word">{{word[2]}}</span>
					</router-link>
					<router-link class="wrapper" to="/seriveTek">
							<span class="word">{{word[3]}}</span>
					</router-link>
					<router-link class="wrapper" to="/Responsibility">
							<span class="word">{{word[4]}}</span>
					</router-link>
					<router-link class="wrapper" to="/Mperson">
							<span class="word last last">{{word[5]}}</span>
					</router-link>
			</div>
		</div>
		<div class="part2">
			<span class="line"></span>
			<div class="left-wrapper">
				<div class="left-wrapper">
					<router-link class="wrapper" to="/prouductCenter/Page1">
					<span class="word first">{{productText[0]}}</span>
					</router-link>
					<router-link class="wrapper" to="/prouductCenter/Page1">
							<span class="word">{{productText[1]}}</span>
					</router-link>
					<router-link class="wrapper" to="/prouductCenter/Page1">
							<span class="word">{{productText[2]}}</span>
					</router-link>
					<router-link class="wrapper" to="/prouductCenter/Page1">
							<span class="word">{{productText[3]}}</span>
					</router-link>
					<router-link class="wrapper" to="/prouductCenter/Page1">
							<span class="word">{{productText[4]}}</span>
					</router-link>
					<router-link class="wrapper" to="/prouductCenter/Page1">
							<span class="word last last">{{productText[5]}}</span>
					</router-link>
					<router-link class="wrapper" to="/prouductCenter/Page1">
							<span class="word last last">{{productText[6]}}</span>
					</router-link>
			</div>
			</div>
		</div>
	</div>
</template>

<script type="text/ecmascript-6">
	import { setup } from "../../main.js"

	export default {
		methods: {
			Drawer() {
				this.$emit('leftTopWhite')
			},
			changeLangEventleft() {
				if(this.$i18n.locale === 'zh') {
					 setup('en')
				} else {
					 setup('zh')
				}
				this.$emit('change')
			}
		},
		computed: {
			word() {
				return this.$t('charpter-one.cp-three-top')
			},
			productText() {
				return this.$t('productText')
			}
		}
	}
</script>

<style lang="stylus" rel="stylesheet/stylus">
	@import "~common/stylus/variable"

	.topleft
		position: absolute
		left: -100%
		top: 0
		bottom: 0
		width: 70%
		background: #eee
		opacity: 0.98
		z-index: 200
		transition: all 0.5s ease
		.wordlang
			position: absolute
			right: 20px
			top: 22px
			color: $color-text-m
		.part1
			width: 70%
			margin: 20% auto 0
			.line
				width: 100%
				height: 1px
				display: block
				background: $color-text-m
			.left-wrapper
				width: 60%
				margin: 8% auto 14%
				display: flex
				flex-direction: column
				align-items: center
				.wrapper
					flex: 1
					padding: 6.5px 0
					border-bottom: 1px solid $color-text-m
					text-align: center
		.part2
			width: 70%
			margin: 0 auto
			.line
				width: 100%
				height: 1px
				display: block
				background: $color-text-m
			.left-wrapper
				width: 60%
				margin: 8px auto
				display: flex
				flex-direction: column
				align-items: center
				.wrapper
					flex: 1
					padding: 6.5px 0
					border-bottom: 1px solid $color-text-m
					.word
						color: $color-text-m
						text-align: center
						float: left
</style>



// WEBPACK FOOTER //
// src/common/top-left/top-left.vue